import * as React from 'react';
import { loadScript, useIsCurrentPageType, useStaticData } from '@avensia/excite';
import { styled } from '@glitz/react';
import { useOnScreen } from '@avensia/excite-ui';

export function TrustyShops() {
  const scriptSettings = useStaticData<NordicNest.Api.ScriptSettingsApiModel>();
  const [isInViewport, ref] = useOnScreen<HTMLLIElement>('400px');
  const isOrderConfirmationPage = useIsCurrentPageType<NordicNest.Api.OrderConfirmationPageApiModel>();

  React.useEffect(() => {
    if (
      (isInViewport || isOrderConfirmationPage) &&
      scriptSettings?.trustedShopsId &&
      (!window.CookieInformation || window.CookieInformation.getConsentGivenFor('cookie_cat_functional'))
    ) {
      window._tsConfig = {
        yOffset: '200' /* offset from page bottom */,
        responsive: { variant: 'custom_reviews', customElementId: 'trusted_div' },
        variant: 'custom_reviews' /* default, reviews, custom, custom_reviews */,
        customElementId: 'trusted_div' /* required for variants custom and custom_reviews */,
        trustcardDirection: '' /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */,
        customBadgeWidth: '' /* for custom variants: 40 - 90 (in pixels) */,
        customBadgeHeight: '' /* for custom variants: 40 - 90 (in pixels) */,
        disableResponsive: 'false' /* deactivate responsive behaviour */,
        disableTrustbadge: 'false' /* deactivate trustbadge */,
      };
      loadScript('//widgets.trustedshops.com/js/' + scriptSettings?.trustedShopsId + '.js');
    }
  }, [isInViewport, isOrderConfirmationPage, scriptSettings?.trustedShopsId]);
  return scriptSettings?.trustedShopsId ? <TrustyShopsPlaceholder ref={ref} id="trusted_div" /> : null;
}

const TrustyShopsPlaceholder = styled.li({
  minHeight: 48,
  minWidth: 48,
});
